<template>
  <div class="">
    <div class="" :class="!isPc ? 'currency-mobile' : 'currency'">
      <div class="breadcrumb" v-show="isPc">
        <div class="crumb"><span>GD</span><span>&gt;</span>
        </div>
        <div class="crumb"><span>{{ getTypeName }}</span><span>&gt;</span></div>
        <div class="crumb"><span>{{ marketInfo.appName }}</span></div>
      </div>
      <!-- <Breadcrumb></Breadcrumb> -->
      <div class="title" v-show="isPc">
        <div><img alt="" srcset="" class="icon" :src="marketInfo.logo">
          {{ marketInfo.appName }}</div>
        <!-- <img class="clicek-points"
          src="@/assets/img/icon_collect.85fa83ab.svg" alt="" srcset=""> -->
      </div>

      <NavM :title="marketInfo.appName" v-if="!isPc" :show-right="false" :is-show-back="true" @back="$router.go(-1)" />
      <!-- {{ leverageList }} -->
      <div :class="!isPc ? 'mobile-content' : ''">
        <div class="chart-page">
          <div class="chart-header">
            <div class="chart-buttons">
              <div class="chart-button clicek-points" @click="showTime = !showTime">{{ timeList[kLineTime].name }} <img
                  src="@/assets/img/icon_arrow_write.c3789592.svg" alt="" srcset="">
                <div class="chart-button-lists clicek-points" v-show="showTime">
                  <div class="chart-button-list" v-for="(item, index) in timeList" :key="index"
                    @click.stop="selectkLineTime(index)"> {{ item.name }}</div>
                </div>
              </div>
            </div>

          </div>

          <!-- <div class="chart-body">
          <div class="chart-logo"><img src="@/assets/img/charts_logo.631a4e6a.svg" alt="" srcset=""></div>
        </div> -->
          <div class="charts-body">
            <div class="charts-body-1"></div>
            <div class="charts-body-1"></div>
            <div class="charts-body-1"></div>
            <div class="charts-body-1"></div>
            <div class="charts-body-1"></div>
            <div class="charts-body-1"></div>
            <div class="charts-body-1"></div>
          </div>

          <div class="charts" id="KlineChart">

          </div>


          <!-- <div class="charts" style="user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);"
          _echarts_instance_="ec_1700456585882">
          <div
            style="position: relative; width: 770px; height: 367px; padding: 0px; margin: 0px; border-width: 0px; cursor: default;">
            <canvas data-zr-dom-id="zr_0" width="1540" height="734"
              style="position: absolute; left: 0px; top: 0px; width: 770px; height: 367px; user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); padding: 0px; margin: 0px; border-width: 0px;"></canvas>
          </div>
          <div class=""
            style=" top: 0px; left: 0px; transform: translate3d(599px, 53px, 0px); visibility: hidden; opacity: 0;">
          </div>
        </div> -->

        </div>
        <div class="content">
          <div style="display: flex;" v-if="marketInfo.canContracts == '1' || marketInfo.canOptions == '1'">
            <div class="change-btn">
              <div class="btn clicek-points" :class="showTypeIndex == index ? 'btn-active' : ''"
                v-for="(item, index) in showTypeList" :key="index" @click="showTypeChange(index)">{{ item.name }}</div>
            </div>
          </div>

          <!-- <div class="trades-menu trades-menu-1">
          <div class="menu1 menu-active">外汇</div>
          <div class="menu1">加密货币</div>
          <div class="menu1">股票</div>
          <div class="menu1">ETF</div>
          <div class="menu1">期货</div>
          <div style="clear: both;"></div>
        </div> -->
          <div v-show="showTypeList[showTypeIndex] && showTypeList[showTypeIndex].value == 'contracts'">
            <div :class="isPc ? 'futures' : 'futures-mobile'">
              <div class="leverage">
                <div class="leverage-title">{{ $t('Market.leverage') }}: {{ this.currentLeverage }}x </div>
                <div class="leverage-progress" ref="myElement" @click="progressClick">
                  <div class="progress" :style="'width: calc(' + positionPercentage + '%)'"></div>
                  <div class="progress-circular progress-1x progress-circular-active"></div>
                  <div class="progress-circular progress-25x progress-circular-active"></div>
                  <div class="progress-circular progress-50x progress-circular-active"></div>
                  <div class="progress-circular progress-75x progress-circular-active"></div>
                  <div class="progress-circular progress-100x progress-circular-active"></div>
                  <div class="progress-circular progress-ring-active clicek-points"
                    :style="'left: calc(' + positionPercentage + '%)'"></div>
                </div>
                <div class="progress-identification">
                  <div :class="`identification-${item.value}x`" v-for="(item, index) in leverageList" :key="index">{{
                    item.name }}X</div>
                </div>
              </div>
              <div style="display: flex;">
                <div class="change-btn change-btn1">
                  <div class="btn clicek-points " :class="priceTypeIndex == index ? 'btn-active' : ''"
                    v-for="(item, index) in priceTypeList" :key="index" @click="priceTypeChange(index)">{{ item }}</div>
                  <!-- <div class="btn clicek-points">限价</div> -->
                </div>
              </div>

              <div style="z-index: 2;margin-top: 25px;" v-show="isPc">
                <div class="inputs">
                  <div class="inputs-div" v-show="priceTypeIndex === 0">{{ marketInfo.price }}</div>
                  <input type="number" class="input" v-model="limitPrice" v-show="priceTypeIndex === 1"
                    :placeholder="$t('Market.Prices')">
                  <div class="add-sub clicek-points" v-show="priceTypeIndex === 1"> + </div>
                  <div class="add-sub clicek-points" v-show="priceTypeIndex === 1"> - </div>
                </div>
              </div>
              <div style="z-index: 1;" v-show="isPc">
                <div class="inputs">
                  <input type="number" v-model="hand" class="input" :placeholder="$t('Market.Sizes')">
                  <div class="add-sub clicek-points" @click="handChange('add')"> + </div>
                  <div class="add-sub clicek-points" @click="handChange('sub')"> - </div>
                </div>
              </div>

              <div style="z-index: 2;" v-show="!isPc">
                <div class="inputs-mobile">
                  <div class="input-buttons">
                    <div class="inputs-div" v-show="priceTypeIndex === 0">{{ marketInfo.price }}</div>
                    <input type="number" class="input" v-model="limitPrice" v-show="priceTypeIndex === 1"
                      :placeholder="$t('Market.Prices')">
                    <div class="add-sub" v-show="priceTypeIndex === 1">+</div>
                    <div class="add-sub" v-show="priceTypeIndex === 1">-</div>
                  </div>
                </div>
              </div>

              <div style="z-index: 1;" v-show="!isPc">
                <div class="inputs-mobile">
                  <div class="input-buttons">
                    <input type="number" v-model="hand" class="input" :placeholder="$t('Market.Sizes')">
                    <div class="add-sub" @click="handChange('add')"> + </div>
                    <div class="add-sub" @click="handChange('sub')"> - </div>
                  </div>
                </div>
              </div>


              <div class="required-all">
                <div class="required"><span class="lable">{{ $t('Market.requiredMargin') }}: </span><span
                    class="number">{{
                      contractsInfoMargin }} USD
                  </span></div>
                <div class="required"><span class="lable">{{ $t('Market.available') }}: </span><span
                    class="number">0.00</span></div>
              </div>
              <div class="profit"><span>{{ $t('Market.takeProfit') }} / {{ $t('Market.stopLoss') }}</span>

                <!-- <label role="checkbox" class="switch toggled toggle-switch"><input type="checkbox" class="switch-input">
                <div class="switch-core" style="background-color: rgb(230, 234, 241);">
                  <div class="switch-button" style="transition: transform 100ms ease 0s;"></div>
                </div>
              </label> -->

                <label role="checkbox" :class="{ toggled: !profit }" @click.stop="profitChange"
                  class="switch  toggle-switch"><input type="checkbox" class="switch-input">
                  <div class="switch-core" @click.stop="">
                    <div class="switch-button" style="transition: transform 100ms ease 0s; "></div>
                  </div>
                </label>


              </div>

              <div class="sell-Long" v-show="profit">
                <div class="sells-Longs clicek-points" @click="switchLong = false">
                  <div class="cir " :class="{ 'cir-active': !switchLong }"></div>
                  <div class="text">{{ $t('Market.sellShort') }}</div>
                </div>
                <div class="sells-Longs clicek-points" @click="switchLong = true">
                  <div class="cir" :class="{ 'cir-active': switchLong }"></div>
                  <div class="text">{{ $t('Market.buyLong') }}</div>
                </div>
              </div>
              <div class="estimation" v-show="profit">
                <div :class="isPc ? '' : 'inputs-mobile'">
                  <div class="" :class="isPc ? 'inputs' : 'input-buttons'">
                    <input type="number" v-model="profitPrice" class="input" placeholder="止盈价格...">
                    <div class="add-sub clicek-points" @click="profitPrice = (Number(profitPrice) + 0.001).toFixed(4)"> +
                    </div>
                    <div class="add-sub clicek-points" @click="profitPrice = (profitPrice - 0.001).toFixed(4)"> - </div>
                  </div>
                </div>
                <div class="estimation-text">{{ $t('Market.estimation') }}: USD </div>
                <div :class="isPc ? '' : 'inputs-mobile'">
                  <div :class="isPc ? 'inputs' : 'input-buttons'"><input type="number" v-model="lossPrice" class="input"
                      placeholder="止损价格...">
                    <div class="add-sub clicek-points" @click="lossPrice = (Number(lossPrice) + 0.001).toFixed(4)"> +
                    </div>
                    <div class="add-sub clicek-points" @click="lossPrice = (lossPrice - 0.001).toFixed(4)"> - </div>
                  </div>
                </div>
                <div class="estimation-text">{{ $t('Market.estimation') }}: - USD </div>
                <div></div>
              </div>
              <div class="button-list">
                <div class="buttons clicek-points buttons-active" @click="contractsSubmit('duo')"
                  v-show="!profit || (profit && switchLong)">{{ $t('Market.buy') }} 7.1368
                </div>
                <div class="buttons clicek-points" @click="contractsSubmit('kong')"
                  v-show="!profit || (profit && !switchLong)">{{ $t('Market.sell') }} 7.1368</div>
              </div>
              <div class="free-list">
                <div class="free">{{ $t('Market.free') }}: {{ contractsTradeFee.toFixed(2) }} USD </div>
              </div>
            </div>
          </div>
          <div v-show="showTypeList[showTypeIndex] && showTypeList[showTypeIndex].value == 'options'">
            <div class="" :class="isPc ? 'main' : 'main-mobile'">
              <div class="times">
                <div class="times-content">
                  <div class="times-content1">
                    <div class="times-button clicek-points" :class="{ 'times-button-active': optionsIndex == index }"
                      @click="optionsIndexChange(index)" v-for="(item, index) in optionsInfo" :key="index">
                      <div class="time">{{ item.seconds }}s</div>
                      <div class="info">{{ item.rate }}% {{ $t('Market.return') }}</div>
                    </div>
                    <!-- <div class="times-button clicek-points">
                    <div class="time">180s</div>
                    <div class="info">80.00% 收益</div>
                  </div>
                  <div class="times-button clicek-points no-margin-right">
                    <div class="time">300s</div>
                    <div class="info">90.00% 收益</div>
                  </div> -->
                  </div>
                </div>
              </div>
              <div class="inputs-count" style="z-index: 2;" v-show="isPc">
                <div class="title">{{ $t('Market.investment') }}:</div>
                <div class="content">
                  <input v-model="optionsMoney" onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^\d.]/g,'')" class="content-input">
                  <span> USD</span>
                </div>
              </div>
              <div class="inputs-buttons" style="z-index: 1;" v-show="isPc">
                <div class="buttons">{{ $t('Market.available') }}: {{ virtualStatus == 1 ? getUserInfo.amount :
                  getUserInfo.virtuallyAmount }} <span>USD</span></div>
                <div class="buttons">{{ $t('Market.frees') }}: {{ optionsTradeFee }} <span>USD</span></div>
              </div>
              <div class="inputs-mobile" v-show="!isPc">
                <div class="input-buttons"><input type="number" class="input" v-model="optionsMoney"
                    :placeholder="$t('Market.investment')">
                  <div class="add-sub" @click="optionsAddd()">+</div>
                  <div class="add-sub" @click="optionsSub()">-</div>
                </div>
              </div>

              <div class="required-all">
                <div class="required"><text class="lable">{{ $t('Market.available') }}: </text><text class="number">{{
                  virtualStatus == 1 ? getUserInfo.amount :
                  getUserInfo.virtuallyAmount }}</text></div>
              </div>

              <div class="button-list" v-show="!isPc">
                <div class="buttons buttons-active" @click="buyOptions('1')">{{ $t('Market.up') }}</div>
                <div class="buttons" @click="buyOptions('2')">{{ $t('Market.down') }}</div>
              </div>


              <div class="button-buttons" v-show="isPc">
                <div class="btn btn-active clicek-points" @click="buyOptions('1')">{{ $t('Market.up') }}</div>
                <div class="btn clicek-points" @click="buyOptions('2')">{{ $t('Market.down') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-butttons"
          v-show="(showTypeList[showTypeIndex] && showTypeList[showTypeIndex].value != 'options')">
          <div class="buttons-big " :class="isPc ? 'buttons-big2' : ''">
            <div class="info-buttons-content">
              <div class="content-icon">
                <img src="@/assets/img/icon_vetor.e4607d5d.svg" alt="">
              </div>
              <div class="content-text">{{ $t('Market.CreateAPlanToTrade') }}! </div>
              <div class="content-text1">{{ $t('Market.WantMoreStableEarning') }}? </div>
              <div class="content-button clicek-points" @click="showSmart">{{ $t('Market.create') }}</div>
            </div>
            <div class="masking"></div>

          </div>
          <div v-show="isPc" class="buttons-big buttons-big1 clicek-points" @click="$router.push('/introduction')">
            <div class="content-icon"></div>
            <div class="content-text">{{ $t('Market.WhatIsSmartTrading') }}?</div>
          </div>
          <div v-show="!isPc" class="wallet"  @click="$router.push('/introduction')"><img  src="@/assets/img/icon_place1.4c6a11aa.svg" alt=""
              srcset=""> {{ $t('Market.WhatIsSmartTrading') }}? </div>
        </div>
        <div class="pop" v-show="optionsPop">
          <!-- optionsLoading -->
          <div class="" @click.stop="isPc ? hideOptuinsPop() :''" v-loading="optionsLoading"  :class="isPc ? 'main' : 'main-mobile'">
            <div class="content" @click.stop=""  >
              <div :class="isPc ? '' : 'info-buttons-content'"> 
                <div class="title">{{ marketInfo.appName }}</div>
              <div class="result-time" v-if="optionsTime > 0 && optionsInfo[optionsIndex]">
                <el-progress type="circle" :stroke-width="2" :width="68" :height="68" :format="format"
                  :percentage="optionsTime * (100 / optionsInfo[optionsIndex].seconds)">
                </el-progress>
              </div>
              <div class="result result-red" v-if="optionsOrderInfo.resultType && optionsOrderInfo.resultType == 1">{{
                optionsOrderInfo.income ? '+' + optionsOrderInfo.income : optionsOrderInfo.income }} USD </div>
              <div class="result result-green" v-if="optionsOrderInfo.resultType && optionsOrderInfo.resultType != 1">{{
                optionsOrderInfo.income }} USD </div>
              <div class="order">{{ $t('account.open') }}: <span>{{ optionsOrderInfo.buyPrice || optionsBuyPrice }}
                  USD</span></div>
              <div class="order">{{ $t('account.lastPrice') }}: <span>{{ optionsOrderInfo.endPrice || optionsCurrentPrice
              }} USD</span></div>
              <div class="order">{{ (optionsBuyType == 1 || optionsOrderInfo.type == 1) ? $t('account.up') :
                $t('account.down') }}: <span>{{ optionsOrderInfo.amount || optionsMoney }} USD</span></div>
              <div class="order">{{ $t('Market.free') }}: <span>{{ optionsOrderInfo.tradeFee || optionsTradeFee }}
                  USD</span></div>
              <div class="order" :class="optionsRevenue > 0 ? 'result-red' : 'result-green'"
                v-show="!optionsOrderInfo.endPrice">{{ $t('account.margin') }}: <span>{{ optionsRevenue }}USD</span></div>
              <div class="order">{{ $t('Market.OrderNumber') }}: <span>{{ orderId }}</span></div>
              </div>
              <div class="button" v-show="isPc && optionsOrderInfo.endPrice" @click="hideOptuinsPop">{{ $t('Market.OrderAgain') }}
              </div>
              </div>
              <div class="button" v-show="!isPc" @click="hideOptuinsPop">{{ $t('Market.OrderAgain') }}
            
            </div>
          </div>
        </div>
      </div>

      <SmartBuy @hide="smartPopHide" :marketInfo="marketInfo" v-if="isSmartPop" />
    </div>
  </div>
</template>

<script>
import SmartBuy from '@/components/Smart.vue'
import Breadcrumb from '@/components/breadcrumb.vue'
import { getKValueByCodeAndDate, getMarketInfo, buyOptions, buyContracts, getOptionsOrderById, getParamByKey } from "@/api/market";
import { mapGetters, mapState } from "vuex";
import { randomNumber } from '@/utils/tools'
import NavM from "@/components/nav_m.vue";
// import chart from '../chart.js'
import $ from 'jquery'
import { getUserInfo } from '@/api/user';
export default {
  components: {
    Breadcrumb,
    SmartBuy,
    NavM
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.getKLineData();
      }, 1000);
    });
    this.getMarketInfo();
    this.getParamByKey('default_trade_fee');
    // 定时器判断当前选择的k线时间来调用刷新k线
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.kLineTime<5) {
      this.timer=setInterval(() => {
        this.$nextTick(() => {
          this.getKLineData();
        });
      }, 1000*60*this.timeList[this.kLineTime].value);
    }
    // 移动到页面最顶部
    window.scrollTo(0, 0);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  data() {
    return {
      defaultTradeFee: 0,
      marketInfo: {},
      timer: null,
      // toggled: true,//止盈 / 止损
      positionPercentage: 100,//进度条位置
      currentLeverage: 0,//当前杠杆
      showTypeIndex: 0,//合约期权index
      priceTypeIndex: 0,//价格类型index
      profit: false,//止盈/止损
      switchLong: false,//false买/买多  true 卖/卖空
      datas: [],//k线数据
      showTime: false,//显示时间列表
      kLineTime: 2,//k线时间，默认15分钟

      startPrice: '',// 合约起始价格
      // 杠杆,
      leverage: 0,
      hand: '',//手数
      profitPrice: '',// 止盈价格
      lossPrice: '',// 止损价格
      // 限价
      limitPrice: '',
      optionsInfo: [],//期权信息
      optionsIndex: 0,//期权index
      // 期权投资金额
      optionsMoney: 0,
      optionsPop: false,//期权弹窗
      optionsTimer: null,//期权定时器
      optionsTime: 1,//期权倒计时
      optionsLoading: false,//期权loading
      optionsId: '',//期权id
      optionsBuyPrice: '',//期权买入价格
      optionsBuyType: '',//期权买入类型
      orderId: '',//期权订单id
      optionsCurrentPrice: '',//期权当前价格
      optionsOrderInfo: {},//期权订单信息
      currentOptionsRate: '',//当前期权收益率
      isSmartPop: false,//智能交易弹窗
    }
  },
  computed: {
    ...mapGetters([
      'getMarkTypeList',
      'marketWsList',
      'getUserInfo',
      'langIndex',
      'virtualStatus',
    ]),
    ...mapState([
      'isPc',
    ]),
    optionsRevenue() {
      if (this.optionsCurrentPrice&&this.optionsBuyPrice&&this.optionsBuyType&&this.optionsMoney&&this.currentOptionsRate) {
        console.log(this.optionsCurrentPrice, this.optionsBuyPrice, this.optionsBuyType, this.optionsMoney);
        // 买涨
        if (this.optionsBuyType==1) {
          return this.optionsCurrentPrice>this.optionsBuyPrice? '+'+(this.optionsMoney*this.currentOptionsRate/100).toFixed(2):-this.optionsMoney;
        }
        // 买跌
        if (this.optionsBuyType==2) {
          return this.optionsCurrentPrice<this.optionsBuyPrice? '+'+(this.optionsMoney*this.currentOptionsRate/100).toFixed(2):-this.optionsMoney;
        }
      } else {
        return 0
      }
    },
    priceTypeList() {
      return [this.$t('Market.market'), this.$t('Market.limit')]//价格类型
    },
    timeList() {
      return [
        {
          name: '1'+this.$t('Market.min'),
          value: '1'
        },
        {
          name: '5'+this.$t('Market.min'),
          value: '5'
        },
        {
          name: '15'+this.$t('Market.min'),
          value: '15'
        },
        {
          name: '30'+this.$t('Market.min'),
          value: '30'
        },
        {
          name: '1'+this.$t('Market.hour'),
          value: '60'
        },
        {
          name: '1'+this.$t('Market.day'),
          value: 'd'
        },
        {
          name: '1'+this.$t('Market.week'),
          value: 'w'
        },
        {
          name: '1'+this.$t('Market.mon'),
          value: 'm'
        },
      ]
    }
    ,
    // 期权交易费
    optionsTradeFee() {
      if (this.optionsMoney) {
        return (this.optionsMoney*this.defaultTradeFee/100).toFixed(2)
      } else {
        return 0
      }
    },
    // 保证金 = 手数 *  杠杆 * 设置的mrgin
    // 交易费等于 保证金 * tradeFee / 100
    // 合约保证金
    contractsInfoMargin() {
      if (this.marketInfo&&this.marketInfo.contractsInfo&&this.marketInfo.contractsInfo.margin&&this.hand) {
        return Number((this.hand*this.marketInfo.contractsInfo.margin/Math.max(this.currentLeverage, 1)).toFixed(2));
      } else {
        return 0
      }
    },
    // 交易费等于
    contractsTradeFee() {
      if (this.marketInfo&&this.marketInfo.contractsInfo&&this.marketInfo.contractsInfo.tradeFee) {
        return this.contractsInfoMargin*this.marketInfo.contractsInfo.tradeFee/100
      } else {
        return 0
      }
    },
    showTypeList() {
      let arr=[]
      //合约期权
      if (this.marketInfo.canContracts=='1') {
        arr.push({
          name: this.$t('Market.contracts'),
          value: 'contracts',
        })
      }
      if (this.marketInfo.canOptions=='1') {
        arr.push({
          name: this.$t('Market.options'),
          value: 'options',
        })
      }

      return arr
    },
    // 计算杠杆
    leverageList() {
      let list=[{
        name: '1',
        value: 1,
      }]
      let num=0
      for (let i=1; i<5; i++) {
        num=this.leverage*(i/4)
        list.push({
          name: num,
          value: 100/(4/i),
        })
      }
      return list
    },
    getTypeName() {
      return this.getMarkTypeList.find(item => item.value==this.$route.query.type).label
    },

    // option() {
    //   return chart.option
    // }
  },
  watch: {
    langIndex() {
      this.getKLineData();
    },
    isPc() {
      this.getKLineData();
    },
    marketWsList: {
      handler: function (val, oldVal) {
        console.log(val);
        if (val[0]) {
          const data=val;
          data.forEach(item => {
            if (item.code==this.marketInfo.code) {
              this.marketInfo.nowPrice=item.price;
              // this.getDefaultProfitAndLoss()
            }
          })
          console.log(this.marketInfo);
        }
      },
      deep: true
    }
  },
  methods: {
    optionsSub() {
      if (this.optionsMoney<=0) {
        return
      }
      this.optionsMoney--
    },
    optionsAddd() {
      if (this.virtualStatus==1) {
        if (this.optionsMoney>=this.getUserInfo.amount) {
          return
        }
      }else{
        if (this.optionsMoney>=this.getUserInfo.virtuallyAmount) {
        return
      }
      }
    
      this.optionsMoney++
    },
    showSmart() {
      console.log(this.marketInfo.canSmart);

      if (this.marketInfo.canSmart!=1) {
        this.$message.error(this.$t('weiKaiQiZhiNengJiaoYi'))
        return
      }

      if (this.virtualStatus!=1) {
        this.$message.error(this.$t('yanShiZhangHuBuNengShiYongZhiNengJiaoYi'))
        return

      }
      this.isSmartPop=true;
    },
    smartPopHide() {
      this.isSmartPop=false;
    },
    getParamByKey(key) {
      getParamByKey(key).then(res => {
        if (res.code=='200') {
          console.log(res.result);
          this.defaultTradeFee=res.result.paramValue
          // this.marketInfo.contractsInfo.tradeFee=res.result.value;
        }
      })
    },
    optionsIndexChange(index) {
      this.optionsIndex=index;
      this.optionsTime=this.optionsInfo[index].seconds;
    },
    hideOptuinsPop() {
      this.optionsPop=false;
      clearInterval(this.optionsTimer);
      this.optionsBuyPrice='';
      this.optionsCurrentPrice='';
      this.optionsMoney=0;
      this.optionsBuyType='';
      this.orderId='';
      this.optionsOrderInfo={};
      this.optionsLoading=false;
      this.optionsIndexChange(this.optionsIndex)

    },
    async buyOptions(type) {
      let params={
        amount: this.optionsMoney,
        optionsId: this.optionsId,
        type: type,
        buyPrice: this.marketInfo.nowPrice||this.marketInfo.price,
        limitTime: this.optionsInfo[this.optionsIndex].seconds,
        marketId: this.marketInfo.id,
      }
      if (params.amount<=0) {
        this.$message.error(this.$t('qingShuRuTouZiJinE'))
        return
      }
      this.currentOptionsRate=this.optionsInfo[this.optionsIndex].rate;
      this.optionsBuyPrice=this.marketInfo.nowPrice||this.marketInfo.price;
      this.optionsCurrentPrice=this.marketInfo.nowPrice||this.marketInfo.price;
      this.optionsBuyType=type;

      this.optionsLoading=true;

      buyOptions(params).then((res) => {
        if (res.code==200) {
          this.optionsPop=false;
          this.$message.success(this.$t('xiaDanChengGong'))
          this.optionsPop=true;
          // 倒计时 一秒一次 60s 期权时间到了就调用接口
          let time=this.optionsTime;
          this.orderId=res.result;
          this.optionsTimer=setInterval(() => {
            time--;
            this.optionsTime=time;
            this.optionsCurrentPrice=Number(randomNumber(this.optionsBuyPrice)).toFixed(4);
            if (time==0) {
              clearInterval(this.optionsTimer);
              this.optionsLoading=true;
              setTimeout(() => {
                this.getOptionsOrderById();
              }, 1000);
              // this.optionsPop=false;
            }
          }, 1000);
        } else {
          this.$message.error(this.$t(res.message))
        }
      }).finally(() => {
        this.optionsLoading=false;
      })
    },

    getOptionsOrderById() {
      this.optionsLoading=true;
      getOptionsOrderById(this.orderId).then(res => {
        if (res.code=='200') {
          if (res.result.status==1) {
            this.optionsOrderInfo=res.result;
            this.optionsCurrentPrice=res.result.currentPrice;
            this.optionsLoading=false;
          } else {
            // 1s重复调用 直到订单状态为1 最多调用10次
            let num=0;
            let timer=setInterval(() => {
              num++;
              if (num>10) {
                clearInterval(timer);
                this.optionsLoading=false;
                this.$message.error(this.$t('wangLuoChaoShiQingQuDingDanLieBiaoChaKanGaiDingDan'));
                this.hideOptuinsPop();
                return
              }
              getOptionsOrderById(this.orderId).then(Response => {
                if (Response.code=='200') {
                  if (Response.result.status==1) {
                    this.optionsOrderInfo=Response.result;
                    this.optionsCurrentPrice=Response.result.currentPrice;
                    this.optionsLoading=false;
                    clearInterval(timer);
                  }
                }
              })
            }, 1000);
          }

        } else {
          this.$message.error(this.$t(res.message))
        }
      })
    },

    format() {
      return `${this.optionsTime}s`;
    },
    handChange(type) {
      if (type=='add') {
        if (this.hand>=100) {
          return
        }
        if (this.hand=='') {
          this.hand=1
          return
        }
        this.hand++
      } else {
        if (this.hand<=1) {
          return this.hand=0
        }
        this.hand--

      }
    },
    getMarketInfo() {
      let id=this.$route.query.id;
      getMarketInfo(id).then(res => {
        let result=res.result;
        this.marketInfo=result;
        if (result.canContracts==1) {
          this.leverage=result.contractsInfo.maxLeverage||0;
          this.currentLeverage=result.contractsInfo.maxLeverage||0;
        } else {
          this.leverage=0;
          this.currentLeverage=0;
        }
        this.startPrice=this.marketInfo.price;
        if (result.canOptions==1&&result.optionsInfo.optionsInfo) {
          this.optionsInfo=JSON.parse(result.optionsInfo.optionsInfo);
          this.optionsTime=this.optionsInfo[this.optionsIndex].seconds;
          this.optionsId=result.optionsInfo.id
        } else {
          this.optionsInfo={};
        }
        if (result.smartInfo.smartInfo) {
          result.smartInfo.smartInfo=JSON.parse(result.smartInfo.smartInfo);
        }
        this.getDefaultProfitAndLoss()
      })
    },
    // 计算止盈止损
    getDefaultProfitAndLoss() {
      if (!this.marketInfo.contractsInfo) {
        return
      }
      let profitPrice=this.marketInfo.price*(100-this.marketInfo.contractsInfo.defaultStop)/100;
      let lossPrice=this.marketInfo.price*(100+this.marketInfo.contractsInfo.defaultStop)/100;
      this.profitPrice=profitPrice.toFixed(4)
      this.lossPrice=lossPrice.toFixed(4)
      console.log(this.profitPrice, this.lossPrice);
    },
    contractsSubmit(type) {
      if (!this.currentLeverage || this.currentLeverage < 1) {
        return this.$message.error('Please select leverage')
      }
      if (!this.hand || this.hand < 1) {
        return this.$message.error('Please enter lots')
      }
      console.log(this.profit);
      if (this.profit) {
        if (this.profitPrice=='') {
          this.$message.error(this.$t('qingShuRuZhiYingJiaGe'))
          return
        }
        if (this.lossPrice=='') {
          this.$message.error(this.$t('qingShuRuZhiSunJiaGe'))
          return
        }
        if (type=='duo') {
          // 买多
          let maxStopProfit=this.marketInfo.price*(100+this.marketInfo.contractsInfo.maxStopProfit)/100;
          let maxStopLoss=this.marketInfo.price*(100-this.marketInfo.contractsInfo.maxStopLoss)/100;
          if (this.profitPrice>maxStopProfit||this.profitPrice<this.marketInfo.price) {
            alert(this.$t('ninShuRuDeZhiYingJiaGeBuHeLi'));
            return
          }
          if (this.lossPrice<maxStopLoss||this.lossPrice>this.marketInfo.price) {
            alert(this.$t('ninShuRuDeZhiSunJiaGeBuHeLi'));
            return
          }
        } else {
          // 卖空
          let maxStopProfit=this.marketInfo.price*(100-this.marketInfo.contractsInfo.maxStopProfit)/100;
          let maxStopLoss=this.marketInfo.price*(100+this.marketInfo.contractsInfo.maxStopLoss)/100;
          if (this.profitPrice<maxStopProfit||this.profitPrice>this.marketInfo.price) {
            alert(this.$t('ninShuRuDeZhiYingJiaGeBuHeLi'));
            return
          }
          if (this.lossPrice>maxStopLoss||this.profitPrice<this.marketInfo.price) {
            alert(this.$t('ninShuRuDeZhiSunJiaGeBuHeLi'));
            return
          }
        }


      }
      const params = {
        marketId: this.marketInfo.id,
        type: type == 'duo' ? 1 : 2,
        hands: Number(this.hand),
        leverage: Number(this.currentLeverage),
        stopProfit: this.profit ? Number(this.profitPrice) : null,
        stopLoss: this.profit ? Number(this.lossPrice) : null,
        limitPrice: this.priceTypeIndex == 1 ? Number(this.limitPrice) : null
      }
      buyContracts(params).then(res => {
        if (res.code == 200) this.$message.success(this.$t('xiaDanChengGong'))
        else this.$message.error(this.$t(res.message))
      })
    },

    profitChange() {
      this.profit=!this.profit
    },
    priceTypeChange(index) {
      this.priceTypeIndex=index;
      if (index==0) {
        this.limitPrice=''
      }
    },
    showTypeChange(index) {
      this.showTypeIndex=index;
    },
    toggledChange() {
      this.toggled=!this.toggled
      console.log(this.toggled);
    },
    selectkLineTime(index) {
      this.kLineTime=index;
      this.showTime=false;
      this.getKLineData();
      // 定时器判断当前选择的k线时间来调用刷新k线
      if (this.timer) {
        clearInterval(this.timer);
      }
      if (this.kLineTime<5) {
        this.timer=setInterval(() => {
          this.getKLineData();
        }, 1000*60*this.timeList[this.kLineTime].value);
      }
    },
    progressClick(event) {
      console.log(111);
      const elementWidth=this.$refs.myElement.offsetWidth;
      const clickX=event.clientX-this.$refs.myElement.getBoundingClientRect().left;
      // positionPercentage最大值为100
      let positionPercentage=Math.floor((clickX/elementWidth)*100);
      if (positionPercentage>100) {
        positionPercentage=100;
      }
      console.log('Click position as a percentage:', positionPercentage);


      this.positionPercentage=positionPercentage;
      this.currentLeverage=Math.floor(this.leverage*(positionPercentage/100));
      console.log(this.currentLeverage);
    },

    async getKLineData(date={}) {
      let params={
        code: this.$route.query.code,
        dateType: this.timeList[this.kLineTime].value,
      }


      console.log(params);

      let _this=this;

      let res=await getKValueByCodeAndDate(params)

      let result=res.result;

      // 要处理成的数据 ['时间', '开', '收', '低', '高', '成交量', 'MA5', 'MA10', 'MA20', 'MA30', 'MACD', 'DIF', 'DEA'],
      // 已有数据 res = [
      // {
      //   "date": "20230705",
      //   "kpPrice": 191.085,
      //   "hignPrice": 192.5,
      //   "lowPrice": 190.14,
      //   "spPrice": 190.85,
      //   "dealNum": 46920261,
      //   "dealPrice": 8990373900
      // }
      // ]

      // 处理数据
      let resData=result.map(item => {
        return [
          item.date||null,
          item.kpPrice||null,
          item.spPrice||null,
          item.lowPrice||null,
          item.hignPrice||null,
          item.dealPrice||null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ]
      })
      if (resData.length==0) {
        resData=[[]]
      }
      console.log(resData);
      let dom=document.getElementById('KlineChart');
      if (!dom) {
        return;
      }
      this.$echarts.dispose(document.getElementById('KlineChart'));
      const myChart=this.$echarts.init(document.getElementById("KlineChart"));
      // myChart.showLoading({
      //   text: 'loading',
      //   color: '#1990ff',
      //   textColor: '#000',
      //   maskColor: 'rgba(255, 255, 255, 0.2)',
      //   zlevel: 0,
      // });
      // myChart.hideLoading();
      // console.log(chart);
      var data=splitData(resData);
      console.log(data);
      var option={}
      var KNAME, data, macd;
      var Zstart=80;
      var Zend=100;
      var MA1=0,
        MA2=0,
        MA3=0,
        MA4=0,
        MA5=0,
        MA6=0;
      var color1='#0CF49B';
      var color2='#FD1050';
      KNAME=this.$route.query.code;
      // 'ETH/USD';

      if (_this.$route.query.type!='1') {
        $(` <div class="k-box pos-box" id='Poskdata'></div>
  <div class="ma-box pos-box" id='Posmadata'>MA</div>
  <div class="vol-box pos-box" id='Posvoldata'>成交量</div>
  `).appendTo($('#KlineChart'));
      } else {
        $(` <div class="k-box pos-box" id='Poskdata'></div>
  <div class="ma-box pos-box" id='Posmadata'>MA</div>
  `).appendTo($('#KlineChart'));
      }





      // <div class="macd-box pos-box" id='Posmacddata'>MACD</div>


      $('.k-box').css({
        top: '35px',
      });

      $('.ma-box').css({
        top: '65px',
      });

      $('.vol-box').css({
        top: '64%',
      });

      // $('.macd-box').css({
      //   top: '79%',
      // });

      $('.option-box').css({
        top: '90%',
        'border-radius': '50%',
        border: '2px solid #FC0107',
        'box-shadow': 'h-shadow v-shadow blur color inset',
        'min-height': '2%',
        'max-width': '2%',
      });

      $('.pos-box').css({
        position: 'absolute',
        left: '10px',
        'z-index': '1',
        padding: '5px',
        'font-size': '13px',
        color: '#ccc',
      });

      $('.p').css({
        padding: 0,
        margin: 0,
      });

      var PosK=document.getElementById('Poskdata');
      var PosMA=document.getElementById('Posmadata');
      var PosVolSelect=document.getElementById('Posvoldata');
      // var PosMacdSelect=document.getElementById('Posmacddata');
      var optionSelect=document.getElementById('Setoption');

      function PosSelect(params) {
        // 获取当前vue实例

        console.log(_this);
        _this.datas={};
        _this.ma={};
        _this.macd={};
        // console.log(params)
        for (var i=0; i<params.length; i++) {
          var el=params[i];
          console.log(el);
          switch (el.seriesIndex) {
            case 0:
              _this.datas={
                color: el.color,
                date: {
                  name: _this.$t('account.time'),
                  value: el.name,
                },
                open: {
                  name: _this.$t('kai'),
                  value: el.value[1],
                },
                close: {
                  name: _this.$t('shou'),
                  value: el.value[2],
                },
                low: {
                  name: _this.$t('di'),
                  value: el.value[3],
                },
                heigh: {
                  name: _this.$t('gao'),
                  value: el.value[4],
                },
                zhangd: {
                  name: _this.$t('zhangFu'),
                  value: (((el.value[2]-el.value[1])/el.value[1])*100).toFixed(2),
                  color: el.color,
                },
                zhenf: {
                  name: _this.$t('zhenFu'),
                  value: ((Math.abs(el.value[4]-el.value[3])/el.value[3])*100).toFixed(2),
                },
              };

              break;

            case 1:
              _this.ma.ma5={
                name: 'MA5',
                value: el.value.toFixed(4),
                color: el.color,
              };
              break;
            case 2:
              _this.ma.ma10={
                name: 'MA10',
                value: el.value.toFixed(4),
                color: el.color,
              };
              break;
            case 3:
              _this.ma.ma20={
                name: 'MA20',
                value: el.value.toFixed(4),
                color: el.color,
              };
              break;
            case 4:
              _this.ma.ma30={
                name: 'MA30',
                value: el.value.toFixed(4),
                color: el.color,
              };
              break;
            case 4:
              break;
            case 5:
              break;
            case 6:
              break;
            case 7:
              _this.vol={
                name: el.seriesName,
                value: el.value,
                color: el.color,
              };
              break;
            case 8:
              _this.macd.macd={
                name: el.seriesName,
                value: el.value,
                color: el.color,
              };
              break;
            case 9:
              _this.macd.dif={
                name: el.seriesName,
                value: el.value,
                color: el.color,
              };
              break;
            case 10:
              _this.macd.dea={
                name: el.seriesName,
                value: el.value,
                color: el.color,
              };
              break;
            default:
              break;
          }
        }

        var objk=Object.keys(_this.datas);
        var ak=[];

        if (_this.isPc) {
          for (let j=1; j<objk.length; j++) {
            ak.push(
              `${_this.datas[objk[j]].name}:<span style="color:${_this.datas[objk[j]].color}">${_this.datas[objk[j]].value
              }</span>&nbsp;`
            );
          }
        } else {
          for (let j=1; j<objk.length; j++) {
            ak.push(
              `${_this.datas[objk[j]].name}:<span style="color:${_this.datas[objk[j]].color}">${_this.datas[objk[j]].value
              }</span> <br>`
            );
          }
        }
        PosK.innerHTML='<p>'+ak.join('')+'</p>';
        var objma=Object.keys(_this.ma);
        var at=[];
        for (var j=0; j<objma.length; j++) {
          at.push(
            `<span style="color:${_this.ma[objma[j]].color}">${_this.ma[objma[j]].name}:${_this.ma[objma[j]].value
            }</span>&nbsp;`
          );
        }
        PosMA.innerHTML=at.join('');

        if (_this.$route.query.type!='1') {
          PosVolSelect.innerHTML=`${_this.vol.name}:<span style="color:${_this.vol.color}">${_this.vol.value}</span>&nbsp;`;
        }


        // var objmacd=Object.keys(_this.macd);
        // var acd=[];
        // for (var j=0; j<objmacd.length; j++) {
        //   acd.push(
        //     `${_this.macd[objmacd[j]].name}:<span style="color:${_this.macd[objmacd[j]].color}">${_this.macd[objmacd[j]].value
        //     }</span>&nbsp;`
        //   );
        // }
        // PosMacdSelect.innerHTML=acd.join('');

        // optionSelect.innerHTML=`<span>指标</span>`;
      }

      function splitData(rawData) {
        var datas=[];
        var times=[];
        var vols=[];
        var macd={
          dif: [],
          dea: [],
          macd: [],
        };
        var m5=[];
        var m10=[];
        var m30=[];
        for (var i=0; i<rawData.length; i++) {
          datas.push(rawData[i]);
          times.push(rawData[i].splice(0, 1)[0]);
          vols.push(rawData[i][4]);
          m5.push(rawData[i][5]);
          m10.push(rawData[i][6]);
          m30.push(rawData[i][7]);
          macd.dea.push(rawData[i][8]);
          macd.dif.push(rawData[i][9]);
          macd.macd.push(rawData[i][10]);
        }
        return {
          datas: datas,
          times: times,
          vols: vols,
          m5: m5,
          m10: m10,
          m30: m30,
          macd: macd,
        };
      }

      function AutoSetMALabel() {
        var mapush=[];
        if (MA1!==0) {
          mapush.push('MA'+MA1[1]);
        }
        if (MA2!==0) {
          mapush.push('MA'+MA2[1]);
        }
        if (MA3!==0) {
          mapush.push('MA'+MA3[1]);
        }
        if (MA4!==0) {
          mapush.push('MA'+MA4[1]);
        }
        if (MA5!==0) {
          mapush.push('MA'+MA5[1]);
        }
        if (MA6!==0) {
          mapush.push('MA'+MA6[1]);
        }
        //console.log(MA2[1])
        return mapush;
      }
      macd=data.macd;
      MA1=data.m5;
      MA2=data.m10;
      MA3=data.m30;
      var highlab=[40, 0],
        lowlab=[-40, 0];
      option={
        backgroundColor: '#000',
        tooltip: {
          show: true,
          trigger: 'axis',
          triggerOn: 'mousemove|click',
          axisPointer: {
            type: 'cross',
          },
          formatter: function (params) {
            var datas;
            if (params.length>0) {
              PosSelect(params);
            }
          },
        },
        xAxis: [
          {
            show: true,
            scale: true,
            nameGap: 15,
            gridIndex: 0,
            splitNumber: 5,
            axisLine: {
              lineStyle: {
                color: '#848484',
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            data: data.times,
            axisPointer: {
              label: {
                show: false,
              },
            }, //主图禁用下标显示
          },
          {
            show: true,
            scale: true,
            nameGap: 15,
            gridIndex: 1,
            splitNumber: 5,
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            data: data.times,
            axisPointer: {
              label: {
                show: false,
              },
            }, //附图1禁用下标显示
          },
          {
            show: true,
            scale: true,
            gridIndex: 2,
            splitNumber: 5,
            axisLine: {
              lineStyle: {
                color: '#848484',
              },
            },
            axisLabel: {
              textStyle: {
                color: '#848484',
              },
            },
            data: data.times,
          },
          {
            gridIndex: 3,
            show: false,
            type: 'value',
          },
        ],
        yAxis: [
          {
            show: true,
            position: 'right',
            scale: true,
            gridIndex: 0,
            axisLine: {
              lineStyle: {
                color: '#848484',
              },
            },
            axisLabel: {
              show: false,
              textStyle: {
                color: '#848484',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '848484',
                type: 'dashed',
              },
            },
            // interval: 40,
          },
          {
            position: 'right',
            // show:false,
            gridIndex: 1,
            splitNumber: 2,
            minInterval: 0,
            axisLine: {
              lineStyle: {
                color: '#848484',
              },
            },
            axisLabel: {
              show: false,
              textStyle: {
                color: '#848484',
              },
            },
            splitLine: {

              show: true,
              lineStyle: {
                color: '848484',
                type: 'dashed',
              },
            },
          },
          {
            position: 'right',
            gridIndex: 2,
            splitNumber: 3,
            axisLine: {
              lineStyle: {
                color: '#848484',
              },
            },
            axisLabel: {
              textStyle: {
                color: '#848484',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '848484',
                type: 'dashed',
              },
            },
          },
          {
            gridIndex: 3,
            show: true,
            type: 'category',
            axisLabel: {
              showMinLabel: false,
              formatter: function (val) {
                return '￥'+val;
              },
              textStyle: {
                color: '#848484',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#848484',
                type: 'dashed',
              },
            },

            axisLine: {
              lineStyle: {
                color: '#848484',
                // 调整高度

              },
            },
          },
        ],
        title: {
          text: KNAME,
          color: '#848484',
        },
        dataZoom: [
          {
            show: false,
            type: 'inside',
            start: Zstart,
            end: Zend,
            xAxisIndex: [0, 0],
          },
          {
            show: false,
            type: 'slider',
            start: Zstart,
            end: Zend,
            xAxisIndex: [0, 1],
          },
          {
            show: false,
            type: 'slider',
            start: Zstart,
            end: Zend,
            xAxisIndex: [0, 2],
          },
          {
            show: false,
          },
        ],
        axisPointer: {
          show: true,
          type: 'line',
          link: [
            {
              xAxisIndex: 'all',
            },
          ],
        },
        toolbox: {
          feature: {
            restore: {},
            dataZoom: {},
            // "magicType": {
            //     "type": ['line', 'bar', 'stack', 'tiled']
            // }
          },
        },
        series: [
          {
            type: 'candlestick',
            // "name": "K线图",
            xAxisIndex: 0,
            yAxisIndex: 0,
            data: data.datas,
            markPoint: {
              symbol: 'circle',
              symbolSize: function (value, param) {
                let size=15;
                if (param.name===this.$t('Market.high')||param.name===this.$t('zuiDiJia')) {
                  size=0.1;
                }
                return size;
              },
              label: {
                show: true,
                fontSize: 12,
                color: '#fff',
                formatter: function (param) {
                  let val='';
                  if (param.name===this.$t('biaoDian')) {
                    val=param.value;
                  } else if (param.name===this.$t('Market.low')) {
                    val=param.value+' →';
                    // lowlab = [-40,0]
                  } else if (param.name===this.$t('Market.high')) {
                    val='← '+param.value;
                    // highlab = [-40,0]
                  }
                  return val;
                },
              },
              data: [
                {
                  name: _this.$t('Market.high'),
                  type: 'max',
                  valueDim: 'highest',
                  symbolOffset: highlab,
                  itemStyle: {
                    color: color2,
                  },
                },
                {
                  name: _this.$t('Market.low'),
                  type: 'min',
                  valueDim: 'lowest',
                  symbolOffset: lowlab,
                  itemStyle: {
                    color: 'rgb(41,60,85)',
                  },
                },
              ],
            },
            markLine: {
              symbol: '',
              data: [
                {
                  yAxis: data.datas[data.datas.length-1][1],
                  label: {
                    position: 'end',
                    padding: 0,
                  },
                  lineStyle: {
                    type: 'dotted',
                    color: '#ccc',
                  },
                },
              ],
            },
            itemStyle: {
              color: color1,
              color0: color2,
              borderColor: color1,
              borderColor0: color2,
            },
          },
          {
            type: 'line',
            name: AutoSetMALabel()[0],
            data: MA1[0],
          },
          {
            type: 'line',
            name: AutoSetMALabel()[1],
            data: MA2[0],
          },
          {
            type: 'line',
            name: AutoSetMALabel()[2],
            data: MA3[0],
          },
          {
            type: 'line',
            name: AutoSetMALabel()[3],
            data: MA4[0],
          },
          {
            type: 'line',
            name: AutoSetMALabel()[4],
            data: MA5[0],
          },
          {
            type: 'line',
            name: AutoSetMALabel()[5],
            data: MA6[0],
          },
          {
            type: 'bar',
            name: this.$t('Market.volume'),
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.vols,
            barCategoryGap: '20%',
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList;
                  if (data.datas[params.dataIndex][1]>data.datas[params.dataIndex][0]) {
                    colorList=color1;
                  } else {
                    colorList=color2;
                  }
                  return colorList;
                },
              },
            },
          },
          // {
          //   type: 'bar',
          //   name: 'MACD',
          //   xAxisIndex: 2,
          //   yAxisIndex: 2,
          //   data: macd.macd,
          //   itemStyle: {
          //     normal: {
          //       color: function (params) {
          //         var colorList;
          //         if (params.data>=0) {
          //           colorList=color1;
          //         } else {
          //           colorList=color2;
          //         }
          //         return colorList;
          //       },
          //     },
          //   },
          // },
          // {
          //   type: 'line',
          //   name: 'DIF',
          //   xAxisIndex: 2,
          //   yAxisIndex: 2,
          //   data: macd.dif,
          //   itemStyle: {
          //     normal: {
          //       color: '#002aff',
          //     },
          //   },
          // },
          // {
          //   type: 'line',
          //   name: 'DEA',
          //   xAxisIndex: 2,
          //   yAxisIndex: 2,
          //   data: macd.dea,
          //   itemStyle: {
          //     normal: {
          //       color: '#ccc',
          //     },
          //   },
          // },
          // {
          //   type: 'line',
          //   xAxisIndex: 3,
          //   yAxisIndex: 3,
          //   areaStyle: {
          //     color: 'red',
          //     opacity: 0.2,
          //   },
          // },
          // {
          //   type: 'line',
          //   xAxisIndex: 3,
          //   yAxisIndex: 3,
          //   areaStyle: {
          //     color: 'red',
          //     opacity: 0.2,
          //   },
          // },
        ],
        legend: [
          {
            data: [],
            show: true,
            padding: 5,
            itemGap: 10,
            itemWidth: 25,
            itemHeight: 14,
          },
          {
            show: false,
            padding: 5,
            itemGap: 10,
            itemWidth: 25,
            itemHeight: 14,
          },
        ],

        grid: [
          {
            show: true,
            top: '60px',
            left: '0.5%',
            right: '0.5%',
            bottom: '35%',
            borderColor: '#848484',
          },
          {
            show: true,
            left: '0.5%',
            right: '0.5%',
            top: '67%',
            bottom: '30px',
            borderColor: '#848484',
          },
          {
            show: false,
            left: '0.5%',
            top: '82%',
            right: '0.5%',
            bottom: '30px',
            borderColor: '#848484',
          },
          {
            left: '100%',
            right: '0%',
            // "height": "60%",
            // "bottom":"35%",
            borderColor: '#848484',
          },
        ],
      };
      console.log(this.$route.query);
      // 当前type == 1 去掉内成交量的内容
      if (this.$route.query.type==1||this.$route.query.type==5) {
        // option.series.splice(6, 1);
        // option.yAxis.splice(1, 1);
        // option.grid.splice(1, 1);
        // 修改图表布局
        option.grid[1].show=false;
        option.grid[0].bottom='0%';
      }
      myChart.setOption(option);


    }
  },




}
</script>
<style scoped lang="scss">
.main {
  margin-top: .26rem
}

.breadcrumb {
  width: 11.2rem;
  margin: auto;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 400;
  font-size: .2rem;
  line-height: 100%;
  color: rgba(0, 0, 0, .5);
  margin-top: .6rem;
  height: .2rem
}

.breadcrumb .crumb {
  float: left
}

.breadcrumb .crumb span {
  margin: 0 .1rem
}

.breadcrumb:after {
  clear: both
}

.main .times .times-content {
  width: 4.56rem;
  margin: auto;
  margin-bottom: .26rem;
  overflow-y: auto
}

.main .times .times-content .times-content1 {
  width: max-content
}

.main .times .times-content .times-content1 .times-button {
  width: 1.08rem;
  height: .9rem;
  background: #f2f2f2;
  border-radius: .1rem;
  float: left;
  margin-right: .08rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column
}

.main .times .times-content .times-content1 .times-button .time {
  font-weight: 700;
  font-size: .22rem;
  color: #000
}

.main .times .times-content .times-content1 .times-button .info {
  font-weight: 400;
  font-size: .14rem;
  color: rgba(0, 0, 0, .5);
  margin-top: .06rem
}

.main .times .times-content .times-content1 .times-button-active {
  background: #fff;
  box-shadow: 0 .1rem .38rem rgba(0, 0, 0, .11)
}

.main .times .times-content .times-content1 .times-button-active .info {
  color: #000
}

.main .inputs-count {
  width: 6.2rem;
  height: .58rem;
  margin-bottom: .1rem;
  background: #fff;
  box-shadow: 0 .14rem .24rem rgba(0, 0, 0, .04);
  border-radius: .16rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 .24rem;
  position: relative
}

.main .inputs-count .content,
.main .inputs-count .title {
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .18rem;
  line-height: 100%;
  text-align: right;
  color: #000;

}

.main .inputs-count .content span {
  color: #3a3dff;
  font-size: .12rem
}

.main .inputs-count .content .content-input {
  text-align: right
}

.main .inputs-buttons {
  width: 6.21rem;
  height: .58rem;
  display: flex;
  justify-content: space-between
}

.main .inputs-buttons .buttons {
  width: 3.08rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .14rem;
  line-height: 100%;
  text-align: center;
  color: #000;
  background: #fff;
  box-shadow: 0 .14rem .24rem rgba(0, 0, 0, .04);
  border-radius: .16rem;
  line-height: .58rem
}

.main .inputs-buttons .buttons span {
  color: #3a3dff;
  font-size: .12rem
}

.main .button-buttons {
  display: flex;
  justify-content: center;
  margin-top: .52rem;
  width: 6.21rem;
  margin-left: .12rem
}

.main .button-buttons .btn {
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .18rem;
  text-align: center;
  color: #000;
  height: .48rem;
  line-height: .5rem;
  padding: 0 .36rem;
  border: .01rem solid #000;
  border-radius: .25rem;
  margin: 0 .05rem
}

.main .button-buttons .btn-active {
  background: linear-gradient(180deg, #ffdc61, #ffbc49);
  height: .5rem;
  border: unset
}



.switch {
  display: inline-block;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  user-select: none;
  font-size: .1rem;
  cursor: pointer;
  margin-left: .1rem;
}

.switch .switch-input {
  display: none;
  position: absolute;
  top: -.22rem
}


.switch .switch-input:focus {
  outline: none
}

.switch .switch-label {
  position: absolute;
  top: 0;
  font-weight: 600;
  color: #fff;
  z-index: 2
}

.switch .switch-label.label-left {
  left: .1rem;
  line-height: .2rem;
  border-top-left-radius: .02rem;
  border-bottom-left-radius: .02rem;
  color: #b5bdc8
}

.switch .switch-label.label-right {
  right: .1rem;
  line-height: .2rem;
  border-top-right-radius: .02rem;
  border-bottom-right-radius: .02rem
}

.switch .switch-core {
  display: block;
  position: relative;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: border-color .3s, background-color .3s;
  user-select: none;
  width: .38rem;
  height: .24rem;
  border-radius: .24rem;
  line-height: .24rem;
  background: #000
}

.switch.toggled .switch-core {
  background: rgb(230, 234, 241);
}

.switch .switch-core .switch-button {
  width: .2rem;
  height: .2rem;
  border-radius: .2rem;
  display: block;
  position: absolute;
  overflow: hidden;
  top: 2;
  left: 2;
  z-index: 3;
  transform: translateZ(0);
  background-color: #fff;
  margin-top: .02rem;
  margin-left: .02rem;
  transform: translate3d(14px, 0px, 0px);
}

.switch.toggled .switch-core .switch-button {
  transform: translate3d(0px, 0px, 0px);
}

.currency .crumbs {
  width: 12rem;
  margin: auto;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 400;
  font-size: .2rem;
  line-height: 100%;
  color: rgba(0, 0, 0, .5);
  margin-top: .6rem
}

.currency .title {
  width: 11.2rem;
  /* margin: auto; */
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 900;
  font-size: .26rem;
  line-height: 100%;
  color: #000;
  margin-top: .34rem;
  height: .46rem;
  line-height: .46rem;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: .3rem;
}

.currency .title .icon {
  height: .46rem;
  margin-right: .1rem;
  vertical-align: top
}

.currency .chart-page {
  width: 10.08rem;
  height: 5.48rem;
  margin: auto;
  background: #000;
  margin-top: .68rem;
  border-radius: .05rem;
  position: relative
}

.currency .chart-page .chart-header {
  height: .268rem;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  /* position: absolute;
  z-index: 999;
  top: 30px; */

}

.currency .chart-page .chart-header .chart-title {
  font-weight: 700;
  font-size: .18rem;
  color: hsla(0, 0%, 100%, .4);
  margin-left: .24rem;
  margin-top: .14rem;
  margin-right: .24rem
}

.currency .chart-page .chart-header .chart-title .chart-title-number {
  font-weight: 700;
  font-size: .16rem;
  color: #fff;
  margin-top: .04rem
}

.currency .chart-page .chart-header .chart-title .chart-title-number .chart-title-number-rand {
  font-weight: 700;
  font-size: .14rem;
  color: #9ee970;
  margin-left: .09rem
}

.currency .chart-page .chart-header .chart-info {
  display: flex;
  justify-content: flex-start;
  margin-top: .32rem
}

.currency .chart-page .chart-header .chart-info .chart-infos {
  margin-right: .24rem;
  font-weight: 400;
  font-size: .14rem;
  line-height: .22rem;
  color: #848484
}

.currency .chart-page .chart-header .chart-info .chart-infos span {
  color: #9ee970
}

.currency .chart-page .chart-header .chart-buttons {
  margin-top: .24rem;
  position: absolute;
  margin-right: .12rem;
  position: absolute;
  top: -5px;
  z-index: 999;
  right: 60px;


}

.currency .chart-page .chart-header .chart-buttons .chart-button {
  width: .9rem;
  height: .4rem;
  border: .01rem solid #fff;
  border-radius: .5rem;
  float: left;
  margin: 0 .12rem;
  text-align: center;
  line-height: .42rem;
  color: #fff;
  font-weight: 600;
  font-size: .16rem;
  position: relative
}

.currency .chart-page .chart-header .chart-buttons .chart-button img {
  vertical-align: middle
}

.currency .chart-page .chart-header .chart-buttons .chart-button .chart-button-lists {
  position: absolute;
  width: .9rem;
  border-radius: .05rem;
  padding: .05rem 0;
  background: #fff;
  z-index: 999
}

.clicek-points {
  cursor: pointer;
}

.currency .chart-page .chart-header .chart-buttons .chart-button .chart-button-lists .chart-button-list {
  width: .9rem;
  height: .4rem;
  text-align: center;
  line-height: .4rem;
  color: #000;
  font-weight: 600;
  font-size: .16rem
}

.currency .chart-page .chart-body {
  width: 100%;
  background: #000;
  position: absolute;
  top: 70%;
  display: flex;
  justify-content: flex-start;
  z-index: 1
}

.currency .chart-page .chart-body .chart-logo {
  width: 1.1rem;
  height: .24rem;
  position: absolute;
  left: .6rem
}

.currency .chart-page .chart-body .chart-infos {
  margin-right: .24rem;
  margin-left: .24rem;
  font-weight: 400;
  font-size: .14rem;
  line-height: .2rem;
  color: #b7ab40;
  position: absolute;
  top: .6rem
}

.currency .chart-page .chart-body .chart-infos1 {
  color: #7f4ca7;
  left: 1.4rem
}

.currency .chart-page .charts {
  width: 100%;
  height: 4.8rem;
  position: absolute
}

.currency .chart-page .charts-body {
  position: absolute;
  width: calc(100% - .88rem);
  margin: auto;
  height: 4rem;
  border-top: .01rem dashed #444;
  margin-top: .1rem;
  left: .44rem
}

.currency .chart-page .charts-body .charts-body-1 {
  width: 100%;
  height: 12.5%;
  border-bottom: .01rem dashed #444
}

.currency .content {
  width: 7.24rem;
  margin: auto;
  /* margin-top: .98rem */
}

.currency .content .change-btn {
  /* width: 2rem; */
  height: .67rem;
  padding: .08rem;
  background: #f2f2f2;
  border-radius: .2rem;
  margin: auto;
  margin-top: .98rem;
}

.currency .content .change-btn .btn {
  width: .91rem;
  height: .52rem;
  text-align: center;
  line-height: .52rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  color: #949494;
  float: left
}

.currency .content .change-btn .btn-active {
  background: #fff;
  box-shadow: 0 .1rem .14rem rgba(0, 0, 0, .12);
  border-radius: .16rem
}

.currency .content1 {
  width: 6.21rem
}

.currency .box-butttons {
  width: 13.2rem;
  margin: auto;
  margin-top: 1.24rem;
  margin-bottom: .65rem;
  display: flex;
  justify-content: space-between
}

.currency .box-butttons .buttons-big {
  width: 6.51rem;
  height: 2.24rem;
  border-radius: .16rem;
  background-size: cover;
  background: #000;
  overflow: hidden;
  position: relative
}

.currency .box-butttons .buttons-big .content-icon {
  width: .28rem;
  height: .28rem;
  background: url('../../../assets/img/icon_vetor.e4607d5d.svg') no-repeat;
  border-radius: .28rem;
  margin: auto;
  margin-top: .34rem
}

.currency .box-butttons .buttons-big .content-text {
  width: 100%;
  height: .24rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 700;
  font-size: .24rem;
  line-height: .24rem;
  color: #fff;
  margin-top: .23rem;
  margin-bottom: .12rem;
  text-align: center
}

.currency .box-butttons .buttons-big .content-text1 {
  width: 100%;
  height: .16rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 300;
  font-size: .16rem;
  line-height: .16rem;
  color: hsla(0, 0%, 100%, .6);
  text-align: center
}

.currency .box-butttons .buttons-big .content-button {
  font-family: Mabry Pro;
  width: .89rem;
  height: .34rem;
  background: #fff;
  border-radius: .22rem;
  font-weight: 500;
  font-size: .14rem;
  line-height: 100%;
  text-align: center;
  line-height: .34rem;
  margin: auto;
  margin-top: .12rem
}

.currency .box-butttons .buttons-big2 .info-buttons-content {
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%
}

.currency .box-butttons .buttons-big2:before {
  content: "";
  width: 1.1rem;
  height: 1.1rem;
  background: linear-gradient(180deg, transparent, #a5a6f5);
  transform: rotate(-30deg);
  display: inline-block;
  border-radius: .55rem;
  position: absolute;
  left: 1rem;
  bottom: -.6rem
}

.currency .box-butttons .buttons-big2:after {
  content: "";
  width: 1.1rem;
  height: 1.1rem;
  background: linear-gradient(180deg, transparent, #9ee970);
  transform: rotate(-110deg);
  display: inline-block;
  border-radius: .55rem;
  position: absolute;
  right: -.3rem;
  top: -.8rem
}

.currency .box-butttons .buttons-big1 {
  background: unset;
  border: .01rem solid #000
}

.currency .box-butttons .buttons-big1 .content-icon {
  width: .31rem;
  height: .31rem;
  background: url('../../../assets/img/icon_place1.4c6a11aa.svg') no-repeat;
  margin: auto;
  margin-top: .8rem;
  background-size: cover;
  border-radius: unset
}

.currency .box-butttons .buttons-big1 .content-text {
  width: 100%;
  height: .24rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 700;
  font-size: .22rem;
  line-height: .22rem;
  color: #000;
  margin-top: .15rem;
  text-align: center
}

.currency-mobile {
  padding-bottom: .4rem
}

.currency-mobile .mobile-content {
  height: max-content
}

.currency-mobile .mobile-content .chart-page {
  width: calc(100% - .48rem);
  height: 5rem;
  border-radius: .12rem;
  background: #000;
  margin: auto;
  margin-top: .8rem;
  position: relative
}

.currency-mobile .mobile-content .chart-page .chart-header {
  // height: 1.1rem;
  width: calc(100% - .48rem);
  padding: .16rem 0 0 0;
  display: flex;
  justify-content: flex-end;
}

.currency-mobile .mobile-content .chart-page .chart-header {
  width: 100%;
  display: flex;
  // justify-content: space-between
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-title {
  font-weight: 700;
  font-size: .18rem;
  color: hsla(0, 0%, 100%, .4)
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-title .chart-title-number {
  font-size: .16rem;
  color: #fff;
  margin-top: .04rem
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-title .chart-title-number span {
  color: #9ee970;
  font-size: .12rem;
  margin-left: .09rem
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-button {
  width: .9rem;
  height: .39rem;
  border: .01rem solid #fff;
  border-radius: .5rem;
  font-weight: 400;
  font-size: .14rem;
  line-height: .39rem;
  color: #fff;
  text-align: center;
  position: absolute;
  right: 1rem;
  z-index: 11;
  top: .13rem;

}

.currency-mobile .mobile-content .chart-page .chart-header .chart-button img {
  vertical-align: middle
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-button .chart-button-lists {
  position: absolute;
  width: .9rem;
  border-radius: .05rem;
  padding: .05rem 0;
  background: #fff;
  z-index: 3
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-button .chart-button-lists .chart-button-list {
  width: .9rem;
  height: .4rem;
  text-align: center;
  line-height: .4rem;
  color: #000;
  font-weight: 600;
  font-size: .16rem
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header2 {
  height: .42rem;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: .26rem
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header2 .chart-header2-button {
  width: 1.4rem;
  height: .42rem;
  border-radius: .42rem;
  font-weight: 600;
  font-size: .16rem;
  line-height: .42rem;
  color: #747474;
  text-align: center
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header2 .chart-header2-button-active {
  color: #fff;
  background: #292929
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header2 .chart-title-number {
  font-size: .16rem;
  color: #fff;
  margin-top: .04rem
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header2 .chart-title-number span {
  color: #9ee970;
  font-size: .12rem;
  margin-left: .09rem
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-info {
  width: 100%;
  margin-top: .16rem;
  height: .6rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-info .chart-infos {
  width: 50%;
  float: left;
  font-weight: 400;
  font-size: .14rem;
  line-height: .22rem;
  color: #848484;
  margin-bottom: .08rem
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-info .chart-infos span {
  color: #9ee970;
  margin-left: .08rem
}

.currency-mobile .mobile-content .chart-page .chart-body {
  width: 100%;
  height: .2rem;
  background: #000;
  position: absolute;
  top: 65%;
  display: flex;
  justify-content: flex-start
}

.currency-mobile .mobile-content .chart-page .chart-body .chart-infos {
  position: absolute;
  width: 1.4rem;
  float: left;
  font-weight: 400;
  font-size: .14rem;
  line-height: .22rem;
  color: #848484;
  margin-left: .22rem;
  margin-bottom: .08rem;
  color: #b7ab40;
  top: .6rem
}

.currency-mobile .mobile-content .chart-page .chart-body .chart-infos1 {
  color: #7f4ca7;
  left: 1.4rem
}

.currency-mobile .mobile-content .chart-page .chart-body .chart-logo {
  width: 1.1rem;
  height: .24rem;
  position: absolute;
  left: .16rem
}

.currency-mobile .mobile-content .chart-page .charts {
  width: 100%;
  height: 3.9rem;
  position: relative
}

.currency-mobile .mobile-content .chart-page .charts-body {
  position: absolute;
  width: 100%;
  margin: auto;
  height: 4rem;
  border-top: .01rem dashed #444;
  margin-top: .1rem
}

.currency-mobile .mobile-content .chart-page .charts-body .charts-body-1 {
  width: 100%;
  height: 14.15%;
  border-bottom: .01rem dashed #444
}

.currency-mobile .mobile-content .content {
  // width: calc(100% - .48rem);
  margin: auto;
  margin-top: .36rem
}

.currency-mobile .mobile-content .content .change-btn {
  width: 1.82rem;
  height: .52rem;
  background: #000;
  border-radius: .2rem;
  padding: .08rem;
  text-align: center;
  margin: auto
}

.currency-mobile .mobile-content .content .change-btn .btn {
  width: 50%;
  line-height: .52rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .16rem;
  color: #fff;
  float: left
}

.currency-mobile .mobile-content .content .change-btn .btn-active {
  height: .52rem;
  background: #fff;
  border-radius: .16rem;
  color: #000
}

.currency-mobile .mobile-content .buttons-big {
  height: 1.52rem;
  background: #000;
  border-radius: .2rem;
  margin-top: .36rem;
  margin: auto;
  padding: .26rem;
  font-family: Mabry Pro;
  font-style: normal;
  position: relative;
  overflow: hidden
}

.currency-mobile .mobile-content .buttons-big .info-buttons-content {
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%
}

.currency-mobile .mobile-content .buttons-big .info-buttons-content .content-icon {
  width: .28rem;
  height: .28rem
}

.currency-mobile .mobile-content .buttons-big .info-buttons-content .content-text {
  font-weight: 500;
  font-size: .22rem;
  line-height: 100%;
  color: #fff;
  margin-top: .16rem
}

.currency-mobile .mobile-content .buttons-big .info-buttons-content .content-text1 {
  font-weight: 300;
  font-size: .14rem;
  line-height: 100%;
  color: hsla(0, 0%, 100%, .6);
  margin-top: .12rem
}

.currency-mobile .mobile-content .buttons-big .info-buttons-content .content-button {
  padding: .14rem .18rem;
  width: .61rem;
  height: .08rem;
  background: #fff;
  border-radius: .22rem;
  font-weight: 500;
  font-size: .16rem;
  line-height: .08rem;
  text-align: center;
  color: #000;
  margin-top: .16rem
}

.currency-mobile .mobile-content .buttons-big:before {
  content: "";
  width: 1.1rem;
  height: 1.1rem;
  background: linear-gradient(180deg, transparent, #a5a6f5);
  transform: rotate(-30deg);
  display: inline-block;
  border-radius: .55rem;
  position: absolute;
  left: 1rem;
  bottom: -.6rem
}

.currency-mobile .mobile-content .buttons-big:after {
  content: "";
  width: 1.1rem;
  height: 1.1rem;
  background: linear-gradient(180deg, transparent, #9ee970);
  transform: rotate(-110deg);
  display: inline-block;
  border-radius: .55rem;
  position: absolute;
  right: -.3rem;
  top: -.8rem
}

.currency-mobile .mobile-content .wallet {
  width: calc(100% - .48rem);
  height: .5rem;
  margin: auto;
  background: #fff;
  border: .01rem solid #000;
  border-radius: .16rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 700;
  font-size: .16rem;
  color: #000;
  text-align: center;
  line-height: .5rem;
  margin-top: .36rem;
  box-sizing: border-box;
  margin-bottom: 1.16rem
}

.currency-mobile .mobile-content .wallet img {
  width: .28rem;
  height: .28rem;
  vertical-align: middle
}

.masking {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  /* background-image: url(../../static/img/noise.90f9bf5b.png); */
  z-index: 1
}

.futures .change-btn {
  /* width: 1.82rem; */
  height: .52rem;
  padding: .08rem;
  background: #f2f2f2;
  border-radius: .2rem;
  margin: auto
}

.futures .change-btn .btn {
  width: .91rem;
  height: .52rem;
  text-align: center;
  line-height: .52rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  color: #949494;
  float: left
}

.futures .change-btn .btn-active {
  background: #fff;
  box-shadow: 0 .1rem .14rem rgba(0, 0, 0, .12);
  border-radius: .16rem
}

.futures .leverage {
  margin-top: .55rem;
  margin-bottom: .5rem
}

.futures .leverage .leverage-title {
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .22rem;
  line-height: 100%;
  color: #000
}

.futures .leverage .leverage-progress {
  width: calc(100% - 12px);
  height: .02rem;
  background: #e7e7e7;
  margin-top: .24rem;
  position: relative
}

.futures .leverage .leverage-progress .progress {
  height: .02rem;
  position: absolute;
  top: 0;
  background: #5254ff
}

.futures .leverage .leverage-progress .progress-circular {
  width: .12rem;
  height: .12rem;
  background: #e7e7e7;
  position: absolute;
  top: -.05rem;
  border-radius: .12rem
}

.futures .leverage .leverage-progress .progress-circular-active {
  background: #5254ff
}

.futures .leverage .leverage-progress .progress-ring-active {
  width: .08rem;
  height: .08rem;
  background: #fff;
  top: -.035rem;
  border: .02rem solid #5254ff
}

.futures .leverage .leverage-progress .progress-1x {
  left: -.01rem
}

.futures .leverage .leverage-progress .progress-25x {
  left: calc(25% - .01rem)
}

.futures .leverage .leverage-progress .progress-50x {
  left: calc(50% - .01rem)
}

.futures .leverage .leverage-progress .progress-75x {
  left: calc(75% - .01rem)
}

.futures .leverage .leverage-progress .progress-100x {
  left: calc(100% - .01rem)
}

.futures .leverage .progress-identification {
  width: 100%;
  height: .16rem;
  margin-top: .14rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .16rem;
  line-height: 100%;
  color: #000;
  position: relative
}

.futures .leverage .progress-identification .identification-1x {
  position: absolute;
  left: 0
}

.futures .leverage .progress-identification .identification-25x {
  position: absolute;
  left: calc(25% - .14rem)
}

.futures .leverage .progress-identification .identification-50x {
  position: absolute;
  left: calc(50% - .14rem)
}

.futures .leverage .progress-identification .identification-75x {
  position: absolute;
  left: calc(75% - .13rem)
}

.futures .leverage .progress-identification .identification-100x {
  position: absolute;
  right: -.08rem
}

.futures .change-btn1 {
  margin-bottom: .16rem
}

.futures .required-all {
  margin-top: .6rem
}

.futures .required-all .required {
  text-align: center;
  margin-bottom: .2rem
}

.futures .required-all .required .lable {
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .18rem;
  line-height: 100%;
  text-align: center;
  color: rgba(0, 0, 0, .5)
}

.futures .required-all .required .number {
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 600;
  font-size: .24rem;
  color: #000
}

.futures .profit {
  text-align: center;
  margin-top: .55rem;
  height: .24rem
}

.futures .profit span {
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 700;
  font-size: .22rem;
  line-height: 100%;
  text-align: center;
  color: #000;
  margin-right: .12rem;
  margin-top: .02rem
}

.futures .profit .toggle-switch {
  top: -.02rem
}

.futures .sell-Long {
  text-align: center;
  margin-top: .55rem;
  display: flex;
  justify-content: center;
  height: .18rem;
  line-height: .18rem;
  font-family: Mabry Pro;
  color: rgba(0, 0, 0, .5);
  font-weight: 500
}

.futures .sell-Long .sells-Longs {
  margin-left: .27rem
}

.futures .sell-Long .sells-Longs .cir {
  width: .12rem;
  height: .12rem;
  border-radius: .1rem;
  margin-right: .07rem;
  border: .01rem solid #000;
  float: left;
  position: relative;
  top: .01rem
}

.futures .sell-Long .sells-Longs .cir-active {
  width: .13rem;
  height: .13rem;
  border-radius: .08rem;
  border: .03rem solid #000
}

.futures .sell-Long .sells-Longs .text {
  float: left
}

.futures .estimation {
  margin-top: .5rem;
}

.futures .estimation .estimation-text {
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .16rem;
  line-height: 100%;
  text-align: center;
  color: rgba(0, 0, 0, .5);
  margin-top: .24rem;
  margin-bottom: .5rem
}

.futures .button-list {
  margin-top: .44rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .18rem;
  line-height: .5rem;
  text-align: center;
  color: #000;
  display: flex;
  justify-content: center
}

.futures .button-list .buttons {
  height: .48rem;
  padding: 0 .36rem;
  border-radius: .48rem;
  margin: 0 .05rem;
  border: .01rem solid #000
}

.futures .button-list .buttons-active {
  /* width: 1.62rem; */
  height: .5rem;
  background: linear-gradient(180deg, #ffdc61, #ffbc49);
  border: unset
}

.futures .free-list {
  display: flex;
  justify-content: center;
  margin-top: .34rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .16rem;
  line-height: 100%;
  text-align: center;
  color: rgba(0, 0, 0, .5)
}

.futures .free-list .free {
  margin: 0 .11rem
}

.futures-mobile {
  width: calc(100% - .48rem);
  margin: auto
}

.trades-menu {
  margin: auto;
  width: max-content;
  height: .52rem;
  background: #f2f2f2;
  border-radius: .2rem;
  margin-top: .26rem;
  margin-bottom: .36rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .16rem;
  line-height: 100%;
  padding: .08rem .08rem
}

.trades-menu .menu1 {
  float: left;
  padding: 0 .16rem;
  line-height: .52rem;
  color: #949494;
  font-family: Mabry Pro;
  cursor: pointer
}

.trades-menu .menu-active {
  font-family: Mabry Pro;
  height: .52rem;
  background: #fff;
  box-shadow: 0 .1rem .14rem rgba(0, 0, 0, .12);
  border-radius: .16rem;
  padding: 0 .16rem;
  text-align: center;
  line-height: .52rem;
  color: #000
}


.inputs {
  width: 100%;
  margin: auto;
  height: .58rem;
  background: #fff;
  box-shadow: 0 .14rem .24rem rgba(0, 0, 0, .04);
  border-radius: .16rem;
  display: flex;
  align-items: center;
  margin-bottom: .08rem;
  position: relative
}

.inputs .input {
  width: 5.7rem;
  height: .58rem;
  border-radius: .16rem;
  padding: 0 .22rem;
  border: unset;
  outline: none
}

.inputs .input::-webkit-input-placeholder {
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 400;
  font-size: .14rem;
  line-height: 100%;
  color: rgba(0, 0, 0, .5)
}

.inputs .input:-moz-placeholder,
.inputs .input::-moz-placeholder {
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 400;
  font-size: .14rem;
  line-height: 100%;
  color: rgba(0, 0, 0, .5)
}

.inputs .input:-ms-input-placeholder {
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 400;
  font-size: .14rem;
  line-height: 100%;
  color: rgba(0, 0, 0, .5)
}

.inputs .input::-webkit-inner-spin-button,
.inputs .input::-webkit-outer-spin-button {
  -webkit-appearance: none
}

.inputs .add-sub {
  width: .46rem;
  height: .46rem;
  background: linear-gradient(180deg, #ffdc61, #ffbc49);
  border-radius: .1rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .26rem;
  text-align: center;
  color: #000;
  margin-right: .06rem;
  display: flex;
  align-items: center;
  justify-content: center
}

.inputs .inputs-div {
  width: 6.35rem;
  height: .58rem;
  line-height: .58rem;
  text-align: center;
  font-weight: 500;
  font-size: .16rem
}

.inputs .btn-type {
  width: .82rem;
  height: .46rem;
  background: #000;
  border-radius: .14rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .16rem;
  line-height: 100%;
  line-height: .46rem;
  text-align: center;
  color: #fff
}

.pop {
  .main {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, .4);
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0 !important;
  }

  ::v-deep .el-progress--circle .el-progress__text,
  .el-progress--dashboard .el-progress__text {
    font-size: 0.16rem !important;
  }

  .main .content {
    width: 5.42rem;
    /* height: 5.82rem; */
    background: #fff;
    border-radius: .18rem;
    font-family: Mabry Pro;
    font-style: normal;
    padding-bottom: .4rem;
  }

  .main .content .title {
    width: 100%;
    font-weight: 700;
    font-size: .38rem;
    line-height: 100%;
    text-align: center;
    color: #000;
    margin-top: .62rem;
    display: flex;
    justify-content: center;
  }

  .main .content .result {
    font-weight: 500;
    font-size: .42rem;
    line-height: 100%;
    text-align: center;
    color: #44b400;
    margin-top: .28rem
  }

  .main .content .result-red {
    color: #ff2828
  }

  .main .content .result-green {
    color: #44b400
  }

  .main .content .result-time {
    width: .74rem;
    height: .74rem;
    margin: auto;
    text-align: center;
    line-height: .74rem;
    margin-top: .28rem;
    border-radius: .74rem;
    font-weight: 700;
    font-size: .18rem;
    color: #000
  }

  .main .content .result-time .info-type-round {
    text-align: center;
    width: .74rem
  }

  .main .content .order {
    width: 100%;
    font-weight: 500;
    font-size: .18rem;
    line-height: 100%;
    text-align: center;
    color: #000;
    margin-top: .28rem
  }

  .main .content .order span {
    font-weight: 800
  }

  .main .content .button {
    // width: 1.47rem;
    width: 1.9rem;
    height: .42rem;
    background: linear-gradient(180deg, #ffdc61, #ffbc49);
    border-radius: .24rem;
    font-family: Mabry Pro;
    font-style: normal;
    font-weight: 500;
    font-size: .18rem;
    line-height: .42rem;
    text-align: center;
    color: #000;
    margin: auto;
    margin-top: .72rem
  }

  .main-mobile {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: #fff;
    margin-top: .8rem;
    z-index: 12;
    line-height: 100%
  }

  .main-mobile .content {
    width: calc(100% - .8rem);
    height: 5.28rem;
    background: #000;
    border-radius: .2rem;
    margin: auto;
    padding: .37rem .16rem;
    font-family: Mabry Pro;
    text-align: center;
    position: relative;
    overflow: hidden
  }

  .main-mobile .content .info-buttons-content {
    position: relative;
    z-index: 2;
    width: calc(100% - .32rem);
    height: 4.28rem;
    top: .37rem;
    left: .16rem
  }

  .main-mobile .content .info-buttons-content .title {
    font-weight: 700;
    font-size: .32rem;
    color: #fff;
    height: .32rem;
    line-height: .32rem
  }

  .main-mobile .content .info-buttons-content .result {
    font-weight: 500;
    font-size: .42rem;
    margin: .28rem auto;
    height: .42rem;
    line-height: .42rem
  }

  .main-mobile .content .info-buttons-content .result-red {
    color: #ff2828
  }

  .main-mobile .content .info-buttons-content .result-green {
    color: #44b400
  }

  .main-mobile .content .info-buttons-content .result-time {
    width: .68rem;
    height: .68rem;
    border-radius: .72rem;
    font-weight: 700;
    font-size: .18rem;
    line-height: .68rem;
    margin: .28rem auto;
    color: #fff
  }

  .main-mobile .content .info-buttons-content .result-time .info-type-round {
    text-align: center;
    width: .68rem;
    color: #fff
  }

  .main-mobile .content .info-buttons-content .order {
    font-weight: 400;
    font-size: .18rem;
    color: #fff;
    margin-bottom: .28rem
  }

  .main-mobile .content .info-buttons-content .order span {
    font-weight: 700
  }

  .main-mobile .content:before {
    background: linear-gradient(180deg, transparent, #9ee970);
    transform: rotate(150deg);
    left: -.35rem;
    top: -.7rem
  }

  .main-mobile .content:after,
  .main-mobile .content:before {
    content: "";
    width: 1.1rem;
    height: 1.1rem;
    display: inline-block;
    border-radius: .55rem;
    position: absolute
  }

  .main-mobile .content:after {
    background: linear-gradient(180deg, transparent, #a5a6f5);
    transform: rotate(-70deg);
    right: -.1rem;
    bottom: -.2rem
  }

  .main-mobile .button {
    // position: fixed;
    position: relative;
    bottom: -.2rem;
    left: 50%;
    margin-left: -.84rem;
    background: #000;
    border-radius: .2rem;
    width: 2rem;
    height: .68rem;
    font-family: Mabry Pro;
    font-style: normal;
    font-weight: 700;
    font-size: .2rem;
    line-height: .68rem;
    text-align: center;
    color: #fff
  }


}


.currency-mobile {
  padding-bottom: .4rem
}

.currency-mobile .mobile-content {
  height: max-content
}

.currency-mobile .mobile-content .chart-page {
  width: calc(100% - .48rem);
  height: 4.8rem;
  border-radius: .12rem;
  background: #000;
  margin: auto;
  margin-top: 1rem;
  position: relative
}

.currency-mobile .mobile-content .chart-page .chart-header {
  // height: 1.1rem;
  // width: calc(100% - .48rem);
  padding: .16rem .14rem 0 .14rem;
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header1 {
  width: 100%;
  display: flex;
  justify-content: space-between
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header1 .chart-title {
  font-weight: 700;
  font-size: .18rem;
  color: hsla(0, 0%, 100%, .4)
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header1 .chart-title .chart-title-number {
  font-size: .16rem;
  color: #fff;
  margin-top: .04rem
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header1 .chart-title .chart-title-number span {
  color: #9ee970;
  font-size: .12rem;
  margin-left: .09rem
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header1 .chart-button {
  width: .9rem;
  height: .39rem;
  border: .01rem solid #fff;
  border-radius: .5rem;
  font-weight: 400;
  font-size: .14rem;
  line-height: .39rem;
  color: #fff;
  text-align: center;
  // position: relative
  position: absolute;
  top: 30px;
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header1 .chart-button img {
  vertical-align: middle
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header1 .chart-button .chart-button-lists {
  position: absolute;
  width: .9rem;
  border-radius: .05rem;
  padding: .05rem 0;
  background: #fff;
  z-index: 3
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header1 .chart-button .chart-button-lists .chart-button-list {
  width: .9rem;
  height: .4rem;
  text-align: center;
  line-height: .4rem;
  color: #000;
  font-weight: 600;
  font-size: .16rem
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header2 {
  height: .42rem;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: .26rem
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header2 .chart-header2-button {
  width: 1.4rem;
  height: .42rem;
  border-radius: .42rem;
  font-weight: 600;
  font-size: .16rem;
  line-height: .42rem;
  color: #747474;
  text-align: center
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header2 .chart-header2-button-active {
  color: #fff;
  background: #292929
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header2 .chart-title-number {
  font-size: .16rem;
  color: #fff;
  margin-top: .04rem
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-header2 .chart-title-number span {
  color: #9ee970;
  font-size: .12rem;
  margin-left: .09rem
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-info {
  width: 100%;
  margin-top: .16rem;
  height: .6rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-info .chart-infos {
  width: 50%;
  float: left;
  font-weight: 400;
  font-size: .14rem;
  line-height: .22rem;
  color: #848484;
  margin-bottom: .08rem
}

.currency-mobile .mobile-content .chart-page .chart-header .chart-info .chart-infos span {
  color: #9ee970;
  margin-left: .08rem
}

.currency-mobile .mobile-content .chart-page .chart-body {
  width: 100%;
  height: .2rem;
  background: #000;
  position: absolute;
  top: 65%;
  display: flex;
  justify-content: flex-start
}

.currency-mobile .mobile-content .chart-page .chart-body .chart-infos {
  position: absolute;
  width: 1.4rem;
  float: left;
  font-weight: 400;
  font-size: .14rem;
  line-height: .22rem;
  color: #848484;
  margin-left: .22rem;
  margin-bottom: .08rem;
  color: #b7ab40;
  top: .6rem
}

.currency-mobile .mobile-content .chart-page .chart-body .chart-infos1 {
  color: #7f4ca7;
  left: 1.4rem
}

.currency-mobile .mobile-content .chart-page .chart-body .chart-logo {
  width: 1.1rem;
  height: .24rem;
  position: absolute;
  left: .16rem
}

.currency-mobile .mobile-content .chart-page .charts {
  width: 100%;
  height: 4.4rem;
  position: relative
}

.currency-mobile .mobile-content .chart-page .charts-body {
  position: absolute;
  width: 100%;
  margin: auto;
  height: 4.6rem;
  border-top: .01rem dashed #444;
  margin-top: .1rem
}

.currency-mobile .mobile-content .chart-page .charts-body .charts-body-1 {
  width: 100%;
  height: 14.15%;
  border-bottom: .01rem dashed #444
}

.currency-mobile .mobile-content .content {
  width: calc(100% - .48rem);
  margin: auto;
  margin-top: .36rem
}

.currency-mobile .mobile-content .content .change-btn {
  width: 1.82rem;
  height: .7rem;
  background: #000;
  border-radius: .2rem;
  padding: .08rem;
  text-align: center;
  margin: auto
}

.currency-mobile .mobile-content .content .change-btn .btn {
  width: 50%;
  line-height: .52rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .16rem;
  color: #fff;
  float: left
}

.currency-mobile .mobile-content .content .change-btn .btn-active {
  height: .52rem;
  background: #fff;
  border-radius: .16rem;
  color: #000
}

.currency-mobile .mobile-content .buttons-big {
  height: 1.52rem;
  background: #000;
  border-radius: .2rem;
  margin-top: .36rem;
  margin: auto;
  padding: .26rem;
  font-family: Mabry Pro;
  font-style: normal;
  position: relative;
  overflow: hidden
}

.currency-mobile .mobile-content .buttons-big .info-buttons-content {
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%
}

.currency-mobile .mobile-content .buttons-big .info-buttons-content .content-icon {
  width: .28rem;
  height: .28rem
}

.currency-mobile .mobile-content .buttons-big .info-buttons-content .content-text {
  font-weight: 500;
  font-size: .22rem;
  line-height: 100%;
  color: #fff;
  margin-top: .16rem
}

.currency-mobile .mobile-content .buttons-big .info-buttons-content .content-text1 {
  font-weight: 300;
  font-size: .14rem;
  line-height: 100%;
  color: hsla(0, 0%, 100%, .6);
  margin-top: .12rem
}

.currency-mobile .mobile-content .buttons-big .info-buttons-content .content-button {
  padding: .14rem .18rem;
  width: .91rem;
  height: .35rem;
  background: #fff;
  border-radius: .22rem;
  font-weight: 500;
  font-size: .16rem;
  line-height: .08rem;
  text-align: center;
  color: #000;
  margin-top: .16rem
}

.currency-mobile .mobile-content .buttons-big:before {
  content: "";
  width: 1.1rem;
  height: 1.1rem;
  background: linear-gradient(180deg, transparent, #a5a6f5);
  transform: rotate(-30deg);
  display: inline-block;
  border-radius: .55rem;
  position: absolute;
  left: 1rem;
  bottom: -.6rem
}

.currency-mobile .mobile-content .buttons-big:after {
  content: "";
  width: 1.1rem;
  height: 1.1rem;
  background: linear-gradient(180deg, transparent, #9ee970);
  transform: rotate(-110deg);
  display: inline-block;
  border-radius: .55rem;
  position: absolute;
  right: -.3rem;
  top: -.8rem
}

.currency-mobile .mobile-content .wallet {
  width: calc(100% - .48rem);
  height: .5rem;
  margin: auto;
  background: #fff;
  border: .01rem solid #000;
  border-radius: .16rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 700;
  font-size: .16rem;
  color: #000;
  text-align: center;
  line-height: .5rem;
  margin-top: .36rem;
  box-sizing: border-box;
  margin-bottom: 1.16rem
}

.currency-mobile .mobile-content .wallet img {
  width: .28rem;
  height: .28rem;
  vertical-align: middle
}


.main-mobile {
  width: calc(100% - .48rem);
  margin: auto;
  margin-top: .24rem
}

.main-mobile .time {
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .26rem;
  line-height: 100%;
  color: #000
}

.main-mobile .times {
  width: 100%;
  overflow-y: hidden;
  margin-top: .21rem;
  margin-bottom: .21rem;
  overflow-x: auto
}

.main-mobile .times .times-content {
  width: max-content
}

.main-mobile .times .times-content .times-button {
  width: 1.04rem;
  height: .86rem;
  background: #fff;
  border: .02rem solid #000;
  border-radius: .1rem;
  float: left;
  margin-left: .08rem;
  text-align: center;
  font-family: Mabry Pro
}

.main-mobile .times .times-content .times-button .time {
  font-weight: 700;
  font-size: .22rem;
  color: #000;
  margin: .24rem 0 .06rem 0
}

.main-mobile .times .times-content .times-button .info {
  font-weight: 400;
  font-size: .14rem;
  color: rgba(0, 0, 0, .5)
}

.main-mobile .times .times-content .times-button-active {
  background: #000
}

.main-mobile .times .times-content .times-button-active .info,
.main-mobile .times .times-content .times-button-active .time {
  color: #fff
}

.main-mobile .required-all {
  margin-top: .3rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .16rem;
  line-height: 100%;
  text-align: center;
  color: rgba(0, 0, 0, .5)
}

.main-mobile .required-all .required {
  margin-bottom: .29rem
}

.main-mobile .required-all .required .number {
  color: #000;
  font-weight: 700
}

.main-mobile .button-list {
  display: flex;
  justify-content: space-between;
  margin-top: .36rem;
  margin-bottom: .9rem
}

.main-mobile .button-list .buttons {
  width: 1.6rem;
  height: .64rem;
  background: #fff;
  border: .02rem solid #000;
  border-radius: .2rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 700;
  font-size: .2rem;
  text-align: center;
  line-height: .64rem
}

.main-mobile .button-list .buttons-active {
  background: #000;
  color: #fff
}

.inputs-mobile {

  width: 100%;
  height: .56rem;
  background: #000;
  border-radius: .16rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: .08rem;
  position: relative;
  padding: .06rem;
  margin-top: .1rem;
}

.inputs-mobile .input-buttons {
  width: 100%;
  height: .46rem;
  background: #fff;
  border-radius: .14rem
}

.inputs-mobile .input-buttons .input {
  height: .36rem;
  float: left;
  line-height: .36rem;
  width: calc(100% - 1.2rem);
  margin: .03rem 0 .03rem .16rem;
}

.inputs-mobile .input-buttons .add-sub {
  width: .36rem;
  height: .36rem;
  background: #000;
  border-radius: .1rem;
  text-align: center;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .2rem;
  color: #fff;
  float: left;
  margin: .05rem .05rem .05rem 0;
  display: flex;
  align-items: center;
  justify-content: center
}

.inputs-mobile .btn-type,
.inputs-mobile .input-buttons .inputs-div {
  height: .46rem;
  line-height: .46rem;
  text-align: center;
  font-weight: 500;
  font-size: .16rem
}

.inputs-mobile .btn-type {
  width: .82rem;
  background: #fff;
  border-radius: .14rem;
  font-family: Mabry Pro;
  font-style: normal;
  color: #000
}

.futures-mobile .leverage {
  margin-top: .36rem;
  margin-bottom: .5rem;
  touch-action: none
}

.futures-mobile .leverage .leverage-title {
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .22rem;
  line-height: 100%;
  color: #000
}

.futures-mobile .leverage .leverage-progress {
  width: 100%;
  height: .02rem;
  background: #e7e7e7;
  margin-top: .24rem;
  position: relative;
  touch-action: none
}

.futures-mobile .leverage .leverage-progress .progress {
  height: .02rem;
  position: absolute;
  top: 0;
  background: #5254ff
}

.futures-mobile .leverage .leverage-progress .progress-circular {
  width: .12rem;
  height: .12rem;
  background: #e7e7e7;
  position: absolute;
  top: -.06rem;
  border-radius: .12rem;
  touch-action: none
}

.futures-mobile .leverage .leverage-progress .progress-circular-active {
  background: #5254ff
}

.futures-mobile .leverage .leverage-progress .progress-ring-active {
  width: .08rem;
  height: .08rem;
  background: #fff;
  top: -.06rem;
  border: .02rem solid #5254ff;
  position: relative;
  z-index: 2;
  touch-action: none
}

.futures-mobile .leverage .leverage-progress .progress-1x {
  left: -.01rem
}

.futures-mobile .leverage .leverage-progress .progress-25x {
  left: 25%
}

.futures-mobile .leverage .leverage-progress .progress-50x {
  left: 50%
}

.futures-mobile .leverage .leverage-progress .progress-75x {
  left: 75%
}

.futures-mobile .leverage .leverage-progress .progress-100x {
  left: 100%
}

.futures-mobile .leverage .progress-identification {
  width: 100%;
  height: .16rem;
  margin-top: .14rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .16rem;
  line-height: 100%;
  color: #000;
  position: relative
}

.futures-mobile .leverage .progress-identification .identification-1x {
  position: absolute;
  left: 0
}

.futures-mobile .leverage .progress-identification .identification-25x {
  position: absolute;
  left: calc(25% - .14rem)
}

.futures-mobile .leverage .progress-identification .identification-50x {
  position: absolute;
  left: calc(50% - .14rem)
}

.futures-mobile .leverage .progress-identification .identification-75x {
  position: absolute;
  left: calc(75% - .13rem)
}

.futures-mobile .leverage .progress-identification .identification-100x {
  position: absolute;
  right: -.08rem
}

.futures-mobile .change-btn1 {
  margin-bottom: .1rem
}

.futures-mobile .required-all {
  margin-top: .5rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .16rem;
  line-height: 100%;
  text-align: center;
  color: rgba(0, 0, 0, .5)
}

.futures-mobile .required-all .required {
  margin-bottom: .1rem
}

.futures-mobile .required-all .required .number {
  color: #000;
  font-weight: 700
}

.futures-mobile .profit {
  margin-top: .32rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 700;
  font-size: .2rem;
  text-align: center
}

.futures-mobile .profit .toggle-switch {
  margin-left: .12rem
}

.futures-mobile .sell-Long {
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .16rem;
  line-height: 100%;
  text-align: center;
  margin-top: .52rem;
  color: rgba(0, 0, 0, .5);
  display: flex;
  justify-content: center;
  margin-bottom: .5rem
}

.futures-mobile .sell-Long .sells-Longs {
  margin: 0 .13rem;
  display: flex;
  justify-content: center
}

.futures-mobile .sell-Long .sells-Longs .cir {
  width: .12rem;
  height: .12rem;
  border-radius: .12rem;
  border: .01rem solid #000;
  margin-right: .1rem
}

.futures-mobile .sell-Long .sells-Longs .cir-active {
  width: .12rem;
  height: .12rem;
  border-radius: .12rem;
  border: .04rem solid #000
}

.futures-mobile .estimation .estimation-text {
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .16rem;
  line-height: 100%;
  text-align: center;
  color: rgba(0, 0, 0, .5);
  margin-top: .16rem;
  margin-bottom: .26rem
}

.futures-mobile .button-list {
  display: flex;
  justify-content: space-around;
  margin-top: .36rem
}

.futures-mobile .button-list .buttons {
  width: 1.6rem;
  height: .64rem;
  background: #fff;
  border: .02rem solid #000;
  border-radius: .2rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 700;
  font-size: .2rem;
  text-align: center;
  line-height: .64rem
}

.futures-mobile .button-list .buttons-active {
  background: #000;
  color: #fff
}

.futures-mobile .free-list {
  display: flex;
  justify-content: space-around;
  margin-top: .22rem;
  margin-bottom: .36rem
}

.futures-mobile .free-list .free {
  width: 1.8rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: .16rem;
  line-height: 100%;
  text-align: center;
  color: rgba(0, 0, 0, .5)
}

.currency-mobile .mobile-content .wallet {
  width: calc(100% - 0.48rem);
  height: 0.5rem;
  margin: auto;
  background: #fff;
  border: 0.01rem solid #000;
  border-radius: 0.16rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 700;
  font-size: .16rem;
  color: #000;
  text-align: center;
  line-height: .5rem;
  margin-top: 0.36rem;
  box-sizing: border-box;
  margin-bottom: 1.16rem;
}

.currency-mobile .mobile-content .buttons-big {
  width: calc(100% - .6rem);
  height: 1.82rem;
  background: #000;
  border-radius: 0.2rem;
  margin-top: 0.36rem;
  margin: auto;
  padding: 0.26rem;
  font-family: Mabry Pro;
  font-style: normal;
  position: relative;
  overflow: hidden;
}
</style>
